import React, { useEffect } from 'react';
import styles from './Pricing.module.scss';
import { PricingPageViewProps } from 'enums/PricingEnums';
import AccountsService from 'services/AccountsService/accounts.service';
import moment from 'moment';
import LoaderAnimation from 'shared/components/LoaderAnimation';

const Pricing = () => {
  const { getPlanDetails, planDetail, loading } = AccountsService();

  useEffect(() => (getPlanDetails(), void 0), []);

  const createdAt =
    planDetail?.createdAt !== null
      ? moment(planDetail?.createdAt).format('MMMM Do YYYY')
      : '';
  const validUpto =
    planDetail?.validUpto !== null
      ? moment(planDetail?.validUpto).format('MMMM Do YYYY')
      : '';
  return (
    <>
      {loading ? (
        <div className={styles.loaderAnimation}>
          <LoaderAnimation />
        </div>
      ) : (
        <div className={styles.mainCardContainer}>
          <div className={styles.contentContainer}>
            <div className={styles.rowOne}>
              <div className={styles.rowOneLineOne}>
                <h2>{PricingPageViewProps.PRICING_HEADING}</h2>
              </div>
              <div className={styles.rowOneLineTwo}>
                <div className={styles.rowOneLineTwoLeft}>
                  <h3 className={styles.rowTwoPlan}>{planDetail?.planName} Plan</h3>
                  <h3 className={styles.rowTwoTimeLine}>
                    {`${createdAt} to ${validUpto}`}
                  </h3>
                </div>
                <div className={styles.rowOneLineTwoRight}>
                </div>
              </div>
            </div>
            <div className={styles.separator}>
              <hr className={styles.horizontalLine} />
            </div>
            <div className={styles.rowTwo}>
              <h2>
                {PricingPageViewProps.NEXT_PAYMENT}
                <strong>
                  {planDetail && ` CA$ ${Number(planDetail?.price).toFixed(2)}`}
                </strong>
              </h2>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Pricing;
